//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'ProteinIntake',
  data() {
    return {
      form:{
        weight:'',
      },
      healthyAdult:'',
      tumorState:'',
      perioperativePeriod:'',
      chronicKidneyDisease:'',
      maintenance:'',
      hasScore:false,
      disabled:false,
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算主要标准 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key]=='---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        self.healthyAdult = (form.weight * 1).toFixed(1) + '~' + (form.weight * 1.16).toFixed(1)
        self.tumorState = (form.weight * 1.2).toFixed(1) + '~' + (form.weight * 2).toFixed(1)
        self.perioperativePeriod = (form.weight * 1.5).toFixed(1) + '~' + (form.weight * 2).toFixed(1)
        self.chronicKidneyDisease = (form.weight * 0.6).toFixed(1) + '~' + (form.weight * 1).toFixed(1)
        self.maintenance = (form.weight * 1).toFixed(1) + '~' + (form.weight * 1.3).toFixed(1)

        // let result = form.weight
        self.hasScore = true
        // return String(result)
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/pages/formulas/GD/ProteinIntake.vue